import { IconPokerChip } from '../../../components/Icon'

/**
 * Pre-draw waiting state. The tournament has a poker phase but
 * the floor hasn't drawn seats yet (`status=NotStarted`, no `seat` on
 * the player view).
 *
 * Calm, branded, informational. Replaces the legacy gray one-line
 * "Pokerturneringen er ikke startet ennå". The card is here to set
 * expectations: you'll see your seat the moment seats are drawn.
 */
const PreDrawView = ({ pokerOnly = false }: { pokerOnly?: boolean }) => (
  <section className="px-4 pt-4 pb-8 flex flex-col items-center text-center gap-6">
    <div className="up text-ink-500">Pokerturneringen</div>
    <div
      className="w-24 h-24 rounded-full flex items-center justify-center text-paper shadow-lg"
      style={{
        background: 'linear-gradient(180deg, #0e2418 0%, #050d09 100%)',
      }}
      aria-hidden
    >
      <IconPokerChip size={56} className="text-gold" />
    </div>
    <div className="space-y-2 max-w-xs">
      <h1 className="font-display text-2xl font-bold text-green-900">
        Klare for poker?
      </h1>
      <p className="text-sm text-ink-700">
        {pokerOnly
          ? 'Dealeren trekker seter når turneringen starter. Du får bord og sete-nummer her med en gang trekningen er gjort.'
          : 'Dealeren trekker seter når golfen er ferdig spilt og innleveringen er bekreftet. Du får bord og sete-nummer her med en gang trekningen er gjort.'}
      </p>
    </div>
    <div className="text-[11px] text-ink-500 max-w-xs">
      Tips: lad telefonen mens du venter — turneringen kan ta noen timer.
    </div>
  </section>
)

export default PreDrawView
